import { BackendApiClient } from '../api-client';
import { azdanceBookingAuthHeaders } from '@/lib/azdanceBookingSession';

/**
 * GET /azdance/profile/me — id участника сессии и `eventBookingId` с сервера.
 */
export async function fetchAztangofestBookingSessionMe(
  language: string,
  accessToken?: string | null,
) {
  return BackendApiClient.AzdanceService.azdanceControllerGetBookingSessionMe(
    { language },
    {
      headers: azdanceBookingAuthHeaders(accessToken ?? undefined),
    } as any,
  );
}
